import { render, staticRenderFns } from "./ChooseModules.vue?vue&type=template&id=4afdd224&scoped=true"
import script from "./ChooseModules.vue?vue&type=script&lang=js"
export * from "./ChooseModules.vue?vue&type=script&lang=js"
import style0 from "./ChooseModules.vue?vue&type=style&index=0&id=4afdd224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdd224",
  null
  
)

export default component.exports